import { useContext } from 'react';
import MultiUiBrandContext from './MultiUiBrandContext';
import { MultiUiBrandContextType } from './type';

const useMultiUiBrandContext = (): MultiUiBrandContextType =>
  useContext(MultiUiBrandContext);

export default useMultiUiBrandContext;
